import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/globalData';

//Court
function createGlobalDataCourt(state, action) {
  state.court.data = action.payload.data ? action.payload.data : [];
}

function connectionGlobalDataCourt(state, action) {
  state.court.connection = action.payload.connection;
}

function errorGlobalDataCourt(state, action) {
  state.court.error = action.payload.error ? action.payload.error : false;
  state.court.message = action.payload.message ? action.payload.message : "";
}

//Location
function createGlobalDataLocation(state, action) {
  state.location.data = action.payload.data ? action.payload.data : [];
}

function connectionGlobalDataLocation(state, action) {
  state.location.connection = action.payload.connection;
}

function errorGlobalDataLocation(state, action) {
  state.location.data = action.payload.error ? action.payload.error : false;
  state.location.message = action.payload.message ? action.payload.message : "";
}

const globalDataReducer = createSlice({
  name: 'globalData',
  initialState: initState,
  reducers: {
    //Court
    createGlobalDataCourt,
    connectionGlobalDataCourt,
    errorGlobalDataCourt,
    //GlobalDataStates
    createGlobalDataLocation,
    connectionGlobalDataLocation,
    errorGlobalDataLocation
  },
});

export const globalDataActions = {
  ...globalDataReducer.actions,
};

export default globalDataReducer.reducer;
